module.exports = "<div class=c-latest-comments__list> <latest-comment v-for=\"comment in commentList\" :body-text=comment.raw_message :author-name=comment.author.name :author-avatar=comment.author.avatar.small.permalink :date=comment.createdAt :scroll-title=comment.scrollTitle :scroll-name=comment.scrollName :copy=comment.copy :scroll-thumbnail=comment.scrollThumbnail :num-of-comments=comment.numOfComments :thread-url=comment.threadUrl> </latest-comment> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/templates/latest-comments-list.html
// module id = 132
// module chunks = 0